class EventBusClass {
	constructor() {
		this.events = {};
	}

	$on(eventName, fn) {
		this.events[eventName] = this.events[eventName] || [];
		this.events[eventName].push(fn);
	}

	$off(eventName, fn) {
		if (this.events[eventName]) {
			if (!fn) {
				delete this.events[eventName];
			} else {
				for (let i = 0; i < this.events[eventName].length; i++) {
					if (this.events[eventName][i] === fn) {
						this.events[eventName].splice(i, 1);
						break;
					}
				}
			}
		}
	}

	$emit(eventName, ...args) {
		if (this.events[eventName]) {
			this.events[eventName].forEach((fn) => {
				fn(...args);
			});
		}
	}
}

export const EventBus = new EventBusClass();
export default EventBus;
